/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
// import { Box, Divider, Typography, Grid } from "@mui/material";
import { Box, Typography } from "@mui/material";
// import React, { useEffect, useState } from "react";
import React from "react";
// import { v4 as uuidv4 } from "uuid";
import Styles from "../../components/AppointmentModals/AddMemberModal/AddMemberModal.style";
import Modal from "../../components/common/Modal/Modal";
// import Button from "../../common/Button";
import Button from "../../components/common/Button";
import { CommonStyles } from "../../components/common/Button/commonButtonStyle";
// import Dropdown from "../../common/new/Dropdown/Dropdown";
import InputField from "../../components/common/new/InputField/InputField";
// import { AlertStatus } from "../../contants";
// import { RELATION_FIELDS } from "../../../contants/formFields";
// import Switch from "../../common/SwitchButton";

function AddUniversityModal({
  open,
  onClose,
  updateData,
  setUpdateData,
  onFormSubmit,
  label,
}) {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUpdateData({
      ...updateData,
      [name]: value,
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    onFormSubmit();
  };
  return (
    <Modal
      open={open}
      onClose={onClose}
      customStyle={{ maxHeight: "95%", maxWidth: "95%" }}
    >
      <Box>
        <Box sx={{ marginBottom: 5 }}>
          <Typography style={Styles.title}>{label}</Typography>
        </Box>
        <form onSubmit={handleSubmit}>
          <InputField
            name="name"
            label="University Name"
            value={updateData.name}
            onChange={handleInputChange}
            required
          />
          <Box style={{ display: "flex", gap: 10 }}>
            <Button
              variant="contained"
              style={CommonStyles.buttonStyle}
              label="Submit"
              type="submit"
            />

            <Button
              variant="outlined"
              onClick={onClose}
              style={CommonStyles.buttonStyle}
              label="Cancel"
            />
          </Box>
        </form>
      </Box>
    </Modal>
  );
}

export default AddUniversityModal;
